function helpers() {

  // anchor scroll function

  $('[data-scroll]').click(function(e) {
    e.preventDefault();

    var target = $(this).attr('href'),
        headerHeight = $('header.header').outerHeight(true),
        targetOffset;

    if ($(target).length > 0) {
      targetOffset = $(target).offset().top - headerHeight;
      
      $('html, body').animate({
        scrollTop: targetOffset
      }, 300);
    }
  });

}